import { DepartmentContext } from "pages/zorgprofessionals/vacatures/[slug]";
import { VacancyDetailImageProps } from "storyblok/components";
import { useContext } from "react";
import Image from "next/legacy/image";

import { Wrapper } from "./VacancyDetailImage.styled";

import { useMediaQueryContext } from "helpers/hooks";

export function VacancyDetailImage({ blok }: VacancyDetailImageProps) {
    const { departments } = blok;
    const department = useContext(DepartmentContext);
    const { isDesktopView } = useMediaQueryContext();

    return (
        <Wrapper>
            {departments.map(d => {
                if (d.department?.toLowerCase() === department?.toLowerCase()) {
                    return (
                        <Image
                            key={`${d.department}-key`}
                            src={d.image.filename}
                            width={!isDesktopView ? 424 : 898}
                            height={!isDesktopView ? 168 : 480}
                            objectFit="cover"
                            draggable={false}
                        />
                    );
                }
            })}
        </Wrapper>
    );
}
